export const HOME_PATH = "/";
export const homeUrl = () => HOME_PATH;
export const GETTING_STARTED_PATH = "/getting-started";
export const gettingStartedUrl = () => GETTING_STARTED_PATH;
export const NOT_FOUND_PATH = "/404";
export const notFoundUrl = () => NOT_FOUND_PATH;

export const LOGIN_PATH = "/login";
export const loginUrl = () => LOGIN_PATH;
export const LOGOUT_PATH = "/logout";
export const logoutUrl = () => LOGOUT_PATH;
export const SIGNUP_PATH = "/signup";
export const signupUrl = () => SIGNUP_PATH;
export const ELEVATE_PATH = "/elevate";
export const elevateUrl = (redirect = "") =>
  `${ELEVATE_PATH}?redirect=${redirect}`;

export const SETTINGS_PATH = "/settings";
export const settingsUrl = () => SETTINGS_PATH;
export const SETTINGS_PROFILE_PATH = "/settings/profile";
export const settingsProfileUrl = () => SETTINGS_PROFILE_PATH;
export const SETTINGS_TOKEN_PATH = "/settings/tokens";
export const settingsTokenUrl = () => SETTINGS_TOKEN_PATH;
export const SETTINGS_TOKEN_READ_PATH = "/settings/tokens/read";
export const settingsTokenReadUrl = () => SETTINGS_TOKEN_READ_PATH;

export const SECURITY_SETTINGS_PATH = "/settings/security";
export const securitySettingsUrl = () => SECURITY_SETTINGS_PATH;
export const SSH_SETTINGS_PATH = "/settings/ssh";
export const sshSettingsUrl = () => SSH_SETTINGS_PATH;
export const SETTINGS_ACCOUNT_INTEGRATIONS_PATH =
  "/settings/account-integrations";
export const settingsAccountIntegrationsUrl = () =>
  SETTINGS_ACCOUNT_INTEGRATIONS_PATH;
export const SETTINGS_ACCOUNT_INTEGRATIONS_AWS_DETAIL_PATH = `${SETTINGS_ACCOUNT_INTEGRATIONS_PATH}/aws/:id`;
export const settingsAccountIntegrationsAwsDetailUrl = (id: string) =>
  `/settings/account-integrations/aws/${id}`;
export const SETTINGS_ACCOUNT_INTEGRATIONS_AWS_DETAIL_RESOURCES_PATH = `${SETTINGS_ACCOUNT_INTEGRATIONS_AWS_DETAIL_PATH}/resources`;
export const settingsAccountIntegrationsAwsResourcesUrl = (id: string) =>
  `${settingsAccountIntegrationsAwsDetailUrl(id)}/resources`;
export const SETTINGS_ACCOUNT_INTEGRATIONS_AWS_DETAIL_SETTINGS_PATH = `${SETTINGS_ACCOUNT_INTEGRATIONS_AWS_DETAIL_PATH}/settings`;
export const settingsAccountIntegrationsAwsSettingsUrl = (id: string) =>
  `${settingsAccountIntegrationsAwsDetailUrl(id)}/settings`;
export const EXTERNAL_AWS_SETTINGS_PATH = "/settings/external-aws";
export const externalAwsSettingsUrl = () => EXTERNAL_AWS_SETTINGS_PATH;
export const OTP_SETUP_PATH = "/settings/otp-setup";
export const otpSetupUrl = () => OTP_SETUP_PATH;
export const OTP_RECOVERY_CODES_PATH = "/settings/otp-recovery-codes";
export const otpRecoveryCodesUrl = () => OTP_RECOVERY_CODES_PATH;
export const ADD_SECURITY_KEY_PATH = "/settings/add-security-key";
export const addSecurityKeyUrl = () => ADD_SECURITY_KEY_PATH;
export const OTP_RESET_VERIFY_PATH =
  "/otp-reset-verify/:challengeId/:verificationCode";
export const otpResetVerifyUrl = (
  challengeId: string,
  verificationCode: string,
) => `/otp-reset-verify/${challengeId}/${verificationCode}`;

export const TEAM_PATH = `${SETTINGS_PATH}/team`;
export const teamUrl = () => TEAM_PATH;
export const TEAM_MEMBERS_PATH = "/settings/team/members";
export const teamMembersUrl = () => TEAM_MEMBERS_PATH;
export const TEAM_INVITE_PATH = "/settings/team/invite";
export const teamInviteUrl = () => TEAM_INVITE_PATH;
export const TEAM_CONTACTS_PATH = "/settings/team/contacts";
export const teamContactsUrl = () => TEAM_CONTACTS_PATH;
export const TEAM_MANAGED_AI_PATH = "/settings/team/managed-ai";
export const teamManagedAiUrl = () => TEAM_MANAGED_AI_PATH;
export const TEAM_SSO_PATH = "/settings/team/sso";
export const teamSsoUrl = () => TEAM_SSO_PATH;
export const TEAM_SCIM_PATH = "/settings/team/scim";
export const teamScimUrl = () => TEAM_SCIM_PATH;
export const TEAM_PENDING_INVITES_PATH = "/settings/team/pending-invites";
export const teamPendingInvitesUrl = () => TEAM_PENDING_INVITES_PATH;
export const TEAM_ROLES_PATH = "/settings/team/roles";
export const teamRolesUrl = () => TEAM_ROLES_PATH;
export const TEAM_ROLES_CREATE_PATH = "/settings/team/roles/create";
export const teamRolesCreateUrl = () => TEAM_ROLES_CREATE_PATH;

export const ROLE_DETAIL_PATH = "/roles/:id";
export const roleDetailUrl = (id: string) => `/roles/${id}`;
export const ROLE_DETAIL_MEMBERS_PATH = "/roles/:id/members";
export const roleDetailMembersUrl = (id: string) => `/roles/${id}/members`;
export const ROLE_DETAIL_ENVIRONMENTS_PATH = "/roles/:id/environments";
export const roleDetailEnvironmentsUrl = (id: string) =>
  `/roles/${id}/environments`;
export const ROLE_DETAIL_SETTINGS_PATH = "/roles/:id/settings";
export const roleDetailSettingsUrl = (id: string) => `/roles/${id}/settings`;

export const TEAM_MEMBERS_EDIT_PATH = "/settings/team/members/:id";
export const teamMembersEditUrl = (id: string) =>
  `/settings/team/members/${id}`;

export const TEAM_ACCEPT_INVITE_PATH = "/claim/:inviteId/:code";
export const teamAcceptInviteUrl = (inviteId: string, code: string) =>
  `/claim/${inviteId}/${code}`;

export const IMPERSONATE_PATH = "/impersonate";
export const impersonateUrl = () => IMPERSONATE_PATH;

export const FORGOT_PASS_PATH = "/forgot-password";
export const forgotPassUrl = () => FORGOT_PASS_PATH;
export const RESET_PASSWORD_PATH =
  "/password/update/:challengeId/:verificationCode";
export const resetPassVerifyUrl = (
  challengeId: string,
  verificationCode: string,
) => `/password/update/${challengeId}/${verificationCode}`;

export const VERIFY_EMAIL_REQUEST_PATH = "/verify";
export const verifyEmailRequestUrl = () => VERIFY_EMAIL_REQUEST_PATH;
export const VERIFY_EMAIL_PATH = "/verify/:verificationId/:verificationCode";
export const verifyEmailUrl = (
  verificationId: string,
  verificationCode: string,
) => `/verify/${verificationId}/${verificationCode}`;

export const HOSTING_PATH = "/hosting";
export const hostingUrl = () => HOSTING_PATH;

export const PLANS_PATH = "/plans";
export const plansUrl = () => PLANS_PATH;

export const BILLING_METHOD_PAGE = "/billing";
export const billingMethodUrl = () => BILLING_METHOD_PAGE;

export const BILLING_INVOICES_PATH = "/settings/billing/invoices";
export const billingInvoicesUrl = () => BILLING_INVOICES_PATH;

export const BILLING_PAYMENT_METHODS_PATH = "/settings/billing/payment-methods";
export const billingPaymentMethodsUrl = () => BILLING_PAYMENT_METHODS_PATH;

export const BILLING_ADD_CREDIT_CARD_PATH =
  "/settings/billing/payment-methods/add-credit-card";
export const billingAddCreditCardUrl = () => BILLING_ADD_CREDIT_CARD_PATH;

export const BILLING_ADD_BANK_ACCOUNT_PATH =
  "/settings/billing/payment-methods/add-bank-account";
export const billingAddBankAccountUrl = () => BILLING_ADD_BANK_ACCOUNT_PATH;

export const BILLING_CONTACTS_PATH = "/settings/billing/contacts";
export const billingContactsUrl = () => BILLING_CONTACTS_PATH;

export const BILLING_ADDRESS_PATH = "/settings/billing/billing-address";
export const billingAddressUrl = () => BILLING_ADDRESS_PATH;

export const SETTINGS_LEGAL_AGREEMENTS_PATH = "/settings/legal/agreements";
export const settingsLegalAgreementsUrl = () => SETTINGS_LEGAL_AGREEMENTS_PATH;

export const SETTINGS_LEGAL_AGREEMENTS_CALLBACK_PATH =
  "/settings/compliance/baa/callback";
export const settingsLegalAgreementsCallbackUrl = () =>
  SETTINGS_LEGAL_AGREEMENTS_CALLBACK_PATH;

export const CREATE_ORG_PATH = "/organizations/create";
export const createOrgUrl = () => CREATE_ORG_PATH;
export const ORG_PICKER_PATH = "/organizations/picker";
export const orgPickerUrl = () => ORG_PICKER_PATH;

export const SSO_REQUIRED_PATH = "/sso-required";
export const ssoRequiredUrl = () => SSO_REQUIRED_PATH;

export const AI_GATEWAY_ENROLL_PATH = "/ai-gateway/enroll";
export const aiGatewayEnrollUrl = () => AI_GATEWAY_ENROLL_PATH;

export const LABS_PATH = "/labs";
export const labsUrl = () => LABS_PATH;

export const LLM_GATEWAY_PATH = "/llm-gateway";
export const llmGatewayUrl = () => LLM_GATEWAY_PATH;
/** The key list, filtered to the active keys limited to more than `spendLimit`. */
export const llmGatewayKeysAboveSpendLimitUrl = (spendLimit: number) =>
  `${LLM_GATEWAY_PATH}?${new URLSearchParams({
    search: `status:active spendlimit:>${spendLimit}`,
  })}`;
export const LLM_GATEWAY_KEY_DETAIL_PATH = "/llm-gateway/llm-keys/:id";
export const llmGatewayKeyDetailUrl = (id: string) =>
  `/llm-gateway/llm-keys/${id}`;
export const LLM_GATEWAY_KEY_REQUESTS_PATH =
  "/llm-gateway/llm-keys/:id/requests";
export const llmGatewayKeyRequestsUrl = (id: string) =>
  `${llmGatewayKeyDetailUrl(id)}/requests`;
export const LLM_GATEWAY_KEY_REQUEST_DETAIL_PATH =
  "/llm-gateway/llm-keys/:id/requests/:requestId";
export const llmGatewayKeyRequestDetailUrl = (id: string, requestId: string) =>
  `${llmGatewayKeyRequestsUrl(id)}/${requestId}`;
export const LLM_GATEWAY_KEY_MODELS_PATH = "/llm-gateway/llm-keys/:id/models";
export const llmGatewayKeyModelsUrl = (id: string) =>
  `${llmGatewayKeyDetailUrl(id)}/models`;
export const LLM_GATEWAY_KEY_SETTINGS_PATH =
  "/llm-gateway/llm-keys/:id/settings";
export const llmGatewayKeySettingsUrl = (id: string) =>
  `${llmGatewayKeyDetailUrl(id)}/settings`;

// Legacy LLM Gateway. Removed once v1 keys are retired.
export const LLM_KEYS_PATH = "/llm-keys";
export const llmKeysUrl = () => LLM_KEYS_PATH;
export const LLM_KEY_DETAIL_PATH = "/llm-keys/:id";
export const llmKeyDetailUrl = (id: string) => `/llm-keys/${id}`;
export const LLM_KEY_MODELS_PATH = "/llm-keys/:id/models";
export const llmKeyModelsUrl = (id: string) => `/llm-keys/${id}/models`;
export const LLM_KEY_REQUESTS_PATH = "/llm-keys/:id/requests";
export const llmKeyRequestsUrl = (id: string) => `/llm-keys/${id}/requests`;
export const LLM_KEY_REQUEST_DETAIL_PATH = "/llm-keys/:id/requests/:requestId";
export const llmKeyRequestDetailUrl = (id: string, requestId: string) =>
  `/llm-keys/${id}/requests/${requestId}`;

export const APPS_PATH = "/apps";
export const appsUrl = () => APPS_PATH;
export const APP_DETAIL_PATH = "/apps/:id";
export const appDetailUrl = (id: string) => `/apps/${id}`;
export const APP_SERVICES_PATH = `${APP_DETAIL_PATH}/services`;
export const appServicesUrl = (id: string) => `${appDetailUrl(id)}/services`;
export const APP_SERVICE_PATH = `${APP_DETAIL_PATH}/services/:serviceId`;
export const appServiceUrl = (appId: string, serviceId: string) =>
  `${appDetailUrl(appId)}/services/${serviceId}`;
export const APP_CONFIG_PATH = `${APP_DETAIL_PATH}/config`;
export const appConfigUrl = (appId: string) => `${appDetailUrl(appId)}/config`;
export const APP_SERVICE_METRICS_PATH = `${APP_DETAIL_PATH}/services/:serviceId/metrics`;
export const appServicePathMetricsUrl = (appId: string, serviceId: string) =>
  `${appDetailUrl(appId)}/services/${serviceId}/metrics`;
export const APP_SERVICE_SCALE_PATH = `${APP_DETAIL_PATH}/services/:serviceId/scale`;
export const appServiceScalePathUrl = (appId: string, serviceId: string) =>
  `${appDetailUrl(appId)}/services/${serviceId}/scale`;
export const APP_SERVICE_SCALE_V2_PATH = `${APP_DETAIL_PATH}/services/:serviceId/scale-v2`;
export const appServiceScaleV2PathUrl = (appId: string, serviceId: string) =>
  `${appDetailUrl(appId)}/services/${serviceId}/scale-v2`;
export const APP_SERVICE_SCALE_V2_MANUAL_PATH = `${APP_SERVICE_SCALE_V2_PATH}/manual`;
export const appServiceScaleV2ManualPathUrl = (
  appId: string,
  serviceId: string,
) => `${appServiceScaleV2PathUrl(appId, serviceId)}/manual`;
export const APP_SERVICE_SCALE_V2_AUTOSCALING_PATH = `${APP_SERVICE_SCALE_V2_PATH}/autoscaling`;
export const appServiceScaleV2AutoscalingPathUrl = (
  appId: string,
  serviceId: string,
) => `${appServiceScaleV2PathUrl(appId, serviceId)}/autoscaling`;
export const APP_SERVICE_SETTINGS_PATH = `${APP_DETAIL_PATH}/services/:serviceId/settings`;
export const appServiceSettingsPathUrl = (appId: string, serviceId: string) =>
  `${appDetailUrl(appId)}/services/${serviceId}/settings`;
export const APP_SERVICE_DISKS_PATH = `${APP_DETAIL_PATH}/services/:serviceId/disk-storage`;
export const appServiceDisksPathUrl = (appId: string, serviceId: string) =>
  `${appDetailUrl(appId)}/services/${serviceId}/disk-storage`;
export const APP_DISKS_PATH = `${APP_DETAIL_PATH}/disk-storage`;
export const appDisksPathUrl = (appId: string) =>
  `${appDetailUrl(appId)}/disk-storage`;
export const APP_ACTIVITY_PATH = `${APP_DETAIL_PATH}/activity`;
export const appActivityUrl = (id: string) => `${appDetailUrl(id)}/activity`;
export const APP_ENDPOINTS_PATH = `${APP_DETAIL_PATH}/endpoints`;
export const appEndpointsUrl = (id: string) => `${appDetailUrl(id)}/endpoints`;
export const APP_ENDPOINT_CREATE_PATH = `${APP_DETAIL_PATH}/endpoints/create`;
export const appEndpointCreateUrl = (id: string) =>
  `${appDetailUrl(id)}/endpoints/create`;
export const APP_SETTINGS_PATH = `${APP_DETAIL_PATH}/settings`;
export const appSettingsUrl = (id: string) => `${appDetailUrl(id)}/settings`;
export const APP_CICD_PATH = `${APP_DETAIL_PATH}/ci-cd`;
export const appCiCdUrl = (id: string) => `${appDetailUrl(id)}/ci-cd`;
export const APP_CICD_GITHUB_PATH = `${APP_DETAIL_PATH}/ci-cd/github`;
export const appCiCdGithubUrl = (id: string) =>
  `${appDetailUrl(id)}/ci-cd/github`;
export const APP_DETAIL_DEPS_PATH = `${APP_DETAIL_PATH}/deps`;
export const appDetailDepsUrl = (id: string) => `/apps/${id}/deps`;
export const APP_DETAIL_DEPLOY_PATH = "/apps/:id/deploy";
export const appDetailDeployUrl = (id: string) => `/apps/${id}/deploy`;
export const APP_DETAIL_DEPLOYMENTS_PATH = "/apps/:id/deployments";
export const appDetailDeploymentsUrl = (id: string) =>
  `/apps/${id}/deployments`;

export const DEPLOYMENT_DETAIL_PATH = "/deployments/:id";
export const deploymentDetailUrl = (id: string) => `/deployments/${id}`;
export const DEPLOYMENT_DETAIL_LOGS_PATH = "/deployments/:id/logs";
export const deploymentDetailLogsUrl = (id: string) =>
  `/deployments/${id}/logs`;
export const DEPLOYMENT_DETAIL_CONFIG_PATH = "/deployments/:id/config";
export const deploymentDetailConfigUrl = (id: string) =>
  `/deployments/${id}/config`;

export const DATABASES_PATH = "/databases";
export const databaseUrl = () => DATABASES_PATH;
export const databasesUrlWithSearch = (search: string) =>
  `${DATABASES_PATH}?search=${encodeURIComponent(search)}`;
export const DATABASE_DETAIL_PATH = "/databases/:id";
export const databaseDetailUrl = (id: string) => `/databases/${id}`;
export const DATABASE_ENDPOINTS_PATH = `${DATABASE_DETAIL_PATH}/endpoints`;
export const databaseEndpointsUrl = (id: string) =>
  `${databaseDetailUrl(id)}/endpoints`;
export const DATABASE_ACTIVITY_PATH = `${DATABASE_DETAIL_PATH}/activity`;
export const databaseActivityUrl = (id: string) =>
  `${databaseDetailUrl(id)}/activity`;
export const DATABASE_BACKUPS_PATH = `${DATABASE_DETAIL_PATH}/backups`;
export const databaseBackupsUrl = (id: string) =>
  `${databaseDetailUrl(id)}/backups`;
export const DATABASE_CLUSTER_PATH = `${DATABASE_DETAIL_PATH}/cluster`;
export const databaseClusterUrl = (id: string) =>
  `${databaseDetailUrl(id)}/cluster`;
export const DATABASE_METRICS_PATH = `${DATABASE_DETAIL_PATH}/metrics`;
export const databaseMetricsUrl = (id: string) =>
  `${databaseDetailUrl(id)}/metrics`;
export const DATABASE_SCALE_PATH = `${DATABASE_DETAIL_PATH}/scale`;
export const databaseScaleUrl = (id: string) =>
  `${databaseDetailUrl(id)}/scale`;
export const DATABASE_SETTINGS_PATH = `${DATABASE_DETAIL_PATH}/settings`;
export const databaseSettingsUrl = (id: string) =>
  `${databaseDetailUrl(id)}/settings`;
export const DATABASE_CREDENTIALS_PATH = `${DATABASE_DETAIL_PATH}/credentials`;
export const databaseCredentialsUrl = (id: string) =>
  `${databaseDetailUrl(id)}/credentials`;
export const DATABASE_ENDPOINT_CREATE_PATH = `${DATABASE_DETAIL_PATH}/endpoints/create`;
export const databaseEndpointCreateUrl = (id: string) =>
  `${databaseDetailUrl(id)}/endpoints/create`;
export const DATABASE_PITR_PATH = `${DATABASE_DETAIL_PATH}/recovery`;
export const databaseRecoveryUrl = (id: string) =>
  `${databaseDetailUrl(id)}/recovery`;

export const SERVICES_PATH = "/services";
export const servicesUrl = () => SERVICES_PATH;
export const servicesUrlWithSearch = (search: string) =>
  `${SERVICES_PATH}?search=${encodeURIComponent(search)}`;

export const BACKUP_RESTORE_PATH = "/backups/:id/restore";
export const backupRestoreUrl = (id: string) => `/backups/${id}/restore`;

export const ENDPOINT_DETAIL_PATH = "/endpoints/:id";
export const endpointDetailUrl = (id: string) => `/endpoints/${id}`;
export const ENDPOINT_DETAIL_ACTIVITY_PATH = "/endpoints/:id/activity";
export const endpointDetailActivityUrl = (id: string) =>
  `${endpointDetailUrl(id)}/activity`;
export const ENDPOINT_DETAIL_SETUP_PATH = "/endpoints/:id/setup";
export const endpointDetailSetupUrl = (id: string) =>
  `${endpointDetailUrl(id)}/setup`;
export const ENDPOINT_DETAIL_SETTINGS_PATH = "/endpoints/:id/settings";
export const endpointDetailSettingsUrl = (id: string) =>
  `${endpointDetailUrl(id)}/settings`;
export const ENDPOINTS_PATH = "/endpoints";
export const endpointsUrl = () => ENDPOINTS_PATH;
export const ENDPOINT_DETAIL_CREDENDTIALS_PATH = "/endpoints/:id/credentials";
export const endpointDetailCredentialsUrl = (id: string) =>
  `/endpoints/${id}/credentials`;

export const ENVIRONMENTS_PATH = "/environments";
export const environmentsUrl = () => ENVIRONMENTS_PATH;
export const ENVIRONMENT_DETAIL_PATH = "/environments/:id";
export const environmentDetailUrl = (id: string) => `/environments/${id}`;
export const ENVIRONMENT_APPS_PATH = "/environments/:id/apps";
export const environmentAppsUrl = (id: string) => `/environments/${id}/apps`;
export const ENVIRONMENT_DATABASES_PATH = "/environments/:id/databases";
export const environmentDatabasesUrl = (id: string) =>
  `/environments/${id}/databases`;
export const ENVIRONMENT_SECURITY_PATH = "/environments/:id/security";
export const environmentSecurityUrl = (id: string) =>
  `/environments/${id}/security`;
export const ENVIRONMENT_INTEGRATIONS_PATH = "/environments/:id/integrations";
export const environmentIntegrationsUrl = (id: string) =>
  `/environments/${id}/integrations`;
export const ENVIRONMENT_CERTIFICATES_PATH = "/environments/:id/certificates";
export const environmentCertificatesUrl = (id: string) =>
  `/environments/${id}/certificates`;
// Legacy route — redirects to ENVIRONMENT_ACTIVITY_PATH
export const ENVIRONMENT_ACTIVITY_REPORTS_LEGACY_PATH =
  "/environments/:id/activity_reports";
export const ENVIRONMENT_ACTIVITY_PATH = "/environments/:id/activity";
export const environmentActivityUrl = (id: string) =>
  `/environments/${id}/activity`;
export const ENVIRONMENT_BACKUPS_PATH = "/environments/:id/backups";
export const environmentBackupsUrl = (id: string) =>
  `/environments/${id}/backups`;
export const ENVIRONMENT_LLM_KEYS_PATH = "/environments/:id/llm-keys";
export const environmentLlmKeysUrl = (id: string) =>
  `/environments/${id}/llm-keys`;
export const ENVIRONMENT_PERSISTENT_DISKS_PATH =
  "/environments/:id/persistent-disks";
export const environmentPersistentDisksUrl = (id: string) =>
  `/environments/${id}/persistent-disks`;
export const ENVIRONMENT_SETTINGS_PATH = "/environments/:id/settings";
export const environmentSettingsUrl = (id: string) =>
  `/environments/${id}/settings`;
export const ENVIRONMENT_CREATE_CERT_PATH =
  "/environments/:id/certificates/create";
export const environmentCreateCertUrl = (id: string) =>
  `/environments/${id}/certificates/create`;
export const ENVIRONMENT_ENDPOINTS_PATH = "/environments/:id/endpoints";
export const environmentEndpointsUrl = (id: string) =>
  `/environments/${id}/endpoints`;

export const environmentCreateAppUrl = (id: string) =>
  `/create/app?environment_id=${id}`;
export const environmentCreateDbUrl = (id: string) =>
  `/create/db?environment_id=${id}`;

export const CREATE_DB_PATH = "/create/db";
export const createDbUrl = (envId?: string) =>
  `${CREATE_DB_PATH}${envId ? `?environment_id=${envId}` : ""}`;

export const ERROR_PATH = "/error";

/*
 * /create -- unauthed page "get started"
 * /create/app -- create a standalone app
 * /create/environment -- create a standalone env
 *
 * /environments/:id/resume -- resume app deployment with just env id
 * /apps/:id/resume -- resume app deployment with just app id
 *
 * /app/:id/get-started -- decision point (git or docker)
 * /app/:id/git -- git push page
 * /app/:id/git/ssh -- add ssh key page
 * /app/:id/deploy/settings -- app configure page (dbs, image registry, env vars, etc)
 * /app/:id/deploy/status -- app deploy status page
 */

export const GET_STARTED_PATH = "/create";
export const getStartedUrl = () => GET_STARTED_PATH;

export const DEPLOY_PATH = "/deploy";
export const deployUrl = (stackId = "") =>
  `${DEPLOY_PATH}${stackId ? `?stack_id=${stackId}` : ""}`;

export const CREATE_APP_PATH = "/create/app";
export const createAppUrl = (params = "") => {
  return `${CREATE_APP_PATH}${params ? `?${params}` : ""}`;
};

export const CREATE_ENV_PATH = "/create/environment";
export const createEnvUrl = (params = "") => {
  return `${CREATE_ENV_PATH}${params ? `?${params}` : ""}`;
};

export const ENV_SELECT_PATH = "/select/env";
export const envSelectUrl = (params = "") =>
  `${ENV_SELECT_PATH}${params ? `?${params}` : ""}`;

export const APP_DEPLOY_RESUME_WITH_ENV_PATH = "/environments/:envId/resume";
export const appDeployResumeWithEnvUrl = (envId: string) =>
  `/environments/${envId}/resume`;

export const APP_DEPLOY_RESUME_PATH = "/apps/:appId/resume";
export const appDeployResumeUrl = (appId: string) => `/apps/${appId}/resume`;

export const APP_DEPLOY_GET_STARTED_PATH = "/apps/:appId/get-started";
export const appDeployGetStartedUrl = (appId: string) =>
  `/apps/${appId}/get-started`;

export const APP_DEPLOY_WITH_GIT_PATH = "/apps/:appId/git";
export const appDeployWithGitUrl = (appId: string) => `/apps/${appId}/git`;
export const APP_DEPLOY_WITH_GITHUB_PATH = "/apps/:appId/github";
export const appDeployWithGithubUrl = (appId: string) =>
  `/apps/${appId}/github`;

export const APP_DEPLOY_WITH_GIT_ADD_KEY_PATH = "/apps/:appId/git/ssh";
export const appDeployWithGitAddKeyUrl = (appId: string) => {
  return `/apps/${appId}/git/ssh`;
};

export const APP_DEPLOY_CONFIGURE_PATH = "/apps/:appId/deploy/configure";
export const appDeployConfigureUrl = (appId: string, query = "") =>
  `/apps/${appId}/deploy/configure${query ? `?${query}` : ""}`;

export const APP_DEPLOY_STATUS_PATH = "/apps/:appId/deploy/status";
export const appDeployStatusUrl = (appId: string) =>
  `/apps/${appId}/deploy/status`;

export const SSO_PATH = "/sso";
export const ssoUrl = () => SSO_PATH;
export const SSO_DIRECT_PATH = "/sso/:orgId";
export const ssoDirectUrl = (orgId: string) => `/sso/${orgId}`;
export const SSO_ORG_FAILURE_PATH = "/sso/failure";
export const ssoFailureUrl = (message = "") =>
  `${SSO_ORG_FAILURE_PATH}?message=${message}`;
export const SSO_TOKEN_CLI_READ_PATH = "/sso/cli/read";
export const ssoTokenReadUrl = () => SSO_TOKEN_CLI_READ_PATH;
export const SSO_TOKEN_CLI_PATH = "/sso/cli";
export const ssoTokenUrl = () => SSO_TOKEN_CLI_PATH;

export const ACTIVITY_BETA_PATH = "/activity-beta";
export const ACTIVITY_LEGACY_PATH = "/activity-legacy";
export const activityLegacyUrl = () => ACTIVITY_LEGACY_PATH;
export const ACTIVITY_PATH = "/activity";
export const activityUrl = () => ACTIVITY_PATH;
export const ACTIVITY_DETAIL_PATH = "/activity/:id";
export const activityDetailUrl = (id: string) => `/activity/${id}`;
export const ACTIVITY_BY_OPERATION_PATH = "/activity/operations/:operationId";
export const activityByOperationUrl = (operationId: string) =>
  `/activity/operations/${operationId}`;
export const ACTIVITY_DETAIL_CONFIG_PATH = "/activity/:id/config";
export const activityDetailConfigUrl = (id: string) => `/activity/${id}/config`;
export const OPERATION_DETAIL_PATH = "/operations/:id";
export const operationDetailUrl = (id: string) => `/operations/${id}`;

export const STYLES_PATH = "/styles";
export const stylesUrl = () => STYLES_PATH;

export const STACKS_PATH = "/stacks";
export const stacksUrl = () => STACKS_PATH;
export const CREATE_STACK_PATH = "/create/stack";
export const createStackUrl = () => CREATE_STACK_PATH;

export const EXTERNAL_AWS_RESOURCES_PATH = "/databases/externalAwsResources";
export const externalAwsResourcesUrl = () => EXTERNAL_AWS_RESOURCES_PATH;
export const EXTERNAL_AWS_RESOURCE_DETAIL_PATH =
  "/databases/externalAwsResources/:id";
export const externalAwsResourceDetailUrl = (id: string) =>
  `/databases/externalAwsResources/${id}`;
export const EXTERNAL_AWS_RESOURCE_CONNECTIONS_PATH = `${EXTERNAL_AWS_RESOURCE_DETAIL_PATH}/connections`;
export const externalAwsResourceConnectionsUrl = (id: string) =>
  `${externalAwsResourceDetailUrl(id)}/connections`;
export const EXTERNAL_AWS_RESOURCE_SETTINGS_PATH = `${EXTERNAL_AWS_RESOURCE_DETAIL_PATH}/settings`;
export const externalAwsResourceSettingsUrl = (id: string) =>
  `${externalAwsResourceDetailUrl(id)}/settings`;

export const STACK_DETAIL_PATH = "/stacks/:id";
export const stackDetailUrl = (id: string) => `/stacks/${id}`;
export const STACK_DETAIL_ENVS_PATH = `${STACK_DETAIL_PATH}/environments`;
export const stackDetailEnvsUrl = (id: string) =>
  `${stackDetailUrl(id)}/environments`;
export const STACK_DETAIL_VPN_TUNNELS_PATH = `${STACK_DETAIL_PATH}/vpn-tunnels`;
export const stackDetailVpnTunnelsUrl = (id: string) =>
  `${stackDetailUrl(id)}/vpn-tunnels`;
export const STACK_DETAIL_VPC_PEERING_PATH = `${STACK_DETAIL_PATH}/vpc-peering`;
export const stackDetailVpcPeeringsUrl = (id: string) =>
  `${stackDetailUrl(id)}/vpc-peering`;
export const STACK_DETAIL_HIDS_PATH = `${STACK_DETAIL_PATH}/hids`;
export const stackDetailHidsUrl = (id: string) => `${stackDetailUrl(id)}/hids`;
export const STACK_DETAIL_SETTINGS_PATH = `${STACK_DETAIL_PATH}/settings`;
export const stackDetailSettingsUrl = (id: string) =>
  `${stackDetailUrl(id)}/settings`;

export const SEARCH_PATH = "/search";
export const searchUrl = () => SEARCH_PATH;

export const SECURITY_CONTROLS_PATH = "/controls";
export const SECURITY_CONTROL_DETAIL_PATH = "/controls/:controlId";
export const SECURITY_CONTROL_IMPLEMENTATION_PATH =
  "/controls/:controlId/implementation";
export const SECURITY_CONTROL_DETAILS_PATH = "/controls/:controlId/details";
export const securityControlsUrl = () => SECURITY_CONTROLS_PATH;
export const securityControlDetailUrl = (id: string) =>
  `${SECURITY_CONTROLS_PATH}/${id}`;
export const securityControlImplementationUrl = (
  id: string,
  searchParams?: URLSearchParams | string,
) => {
  const base = `${SECURITY_CONTROLS_PATH}/${id}/implementation`;
  if (!searchParams) return base;
  const query =
    typeof searchParams === "string" ? searchParams : searchParams.toString();
  return query ? `${base}?${query}` : base;
};
export const securityControlDetailsUrl = (
  id: string,
  searchParams?: URLSearchParams | string,
) => {
  const base = `${SECURITY_CONTROLS_PATH}/${id}/details`;
  if (!searchParams) return base;
  const query =
    typeof searchParams === "string" ? searchParams : searchParams.toString();
  return query ? `${base}?${query}` : base;
};

export const CERT_DETAIL_PATH = "/certificates/:id";
export const certDetailUrl = (id: string) => `/certificates/${id}`;
export const CERT_DETAIL_APPS_PATH = "/certificates/:id/apps";
export const certDetailAppsUrl = (id: string) => `/certificates/${id}/apps`;
export const CERT_DETAIL_ENDPOINTS_PATH = "/certificates/:id/endpoints";
export const certDetailEndpointsUrl = (id: string) =>
  `/certificates/${id}/endpoints`;
export const CERT_DETAIL_SETTINGS_PATH = "/certificates/:id/settings";
export const certDetailSettingsUrl = (id: string) =>
  `/certificates/${id}/settings`;

export const CREATE_METRIC_DRAIN_PATH = "/metric-drains/create";
export const createMetricDrainUrl = (envId = "") =>
  `${CREATE_METRIC_DRAIN_PATH}${envId ? `?environment_id=${envId}` : ""}`;
export const CREATE_LOG_DRAIN_PATH = "/log-drains/create";
export const createLogDrainUrl = (envId = "") =>
  `${CREATE_LOG_DRAIN_PATH}${envId ? `?environment_id=${envId}` : ""}`;
export const CREATE_LLM_TRACE_DRAIN_PATH = "/llm-trace-drains/create";
export const createLlmTraceDrainUrl = (envId = "") =>
  `${CREATE_LLM_TRACE_DRAIN_PATH}${envId ? `?environment_id=${envId}` : ""}`;

// VPC Peering Request (stack-scoped create page)
export const STACK_DETAIL_VPC_PEERING_CREATE_PATH = `${STACK_DETAIL_PATH}/vpc-peering/create`;
export const stackDetailVpcPeeringCreateUrl = (id: string) =>
  `${stackDetailUrl(id)}/vpc-peering/create`;

export const SUPPORT_URL = "/support";
export const supportUrl = (params?: {
  subject?: string;
  message?: string;
}) => {
  if (!params || Object.keys(params).length === 0) return SUPPORT_URL;

  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    searchParams.set(key, value);
  });

  const query = searchParams.toString();

  return query ? `${SUPPORT_URL}?${query}` : SUPPORT_URL;
};

export const PRINT_CONTROLS_PATH = "/print-controls";
export const printControlsUrl = (params?: {
  scope?: string;
  category?: string;
  framework?: string;
  autoPrint?: boolean;
}) => {
  if (!params) return PRINT_CONTROLS_PATH;
  const searchParams = new URLSearchParams();
  if (params.scope) searchParams.set("scope", params.scope);
  if (params.category) searchParams.set("category", params.category);
  if (params.framework) searchParams.set("framework", params.framework);
  if (params.autoPrint) searchParams.set("autoPrint", "1");
  const query = searchParams.toString();
  return query ? `${PRINT_CONTROLS_PATH}?${query}` : PRINT_CONTROLS_PATH;
};

export const SOURCES_PATH = "/sources";
export const sourcesUrl = () => SOURCES_PATH;
export const SOURCES_SETUP_PATH = "/sources/setup";
export const sourcesSetupUrl = () => SOURCES_SETUP_PATH;
export const SOURCE_DETAIL_PATH = "/sources/:id";
export const sourceDetailUrl = (id: string) => `/sources/${id}`;
export const SOURCE_DETAIL_APPS_PATH = "/sources/:id/apps";
export const sourceDetailAppsUrl = (id: string) => `/sources/${id}/apps`;
export const SOURCE_DETAIL_DEPLOYMENTS_PATH = "/sources/:id/deployments";
export const sourceDetailDeploymentsUrl = (id: string) =>
  `/sources/${id}/deployments`;
